import styled from 'styled-components';

export const CommonFormWrapper = styled.form`
  width: 700px;
  margin: 50px auto;
  text-align: left;
`

export const CommonWrapper = styled.fieldset`
  width: 420px;
  height: auto;
  margin:  50px auto;
`;


export const CommonTitle = styled.legend`
  color: #0094B5;
  font-size: 30px;
  margin-bottom: 60px;
  text-align: center;
  font-weight: 700;
`;

export const CommonSubText = styled.p`
  color: #333333;
  font-size: 20px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 700;
`;


export const CommonLabel = styled.label`
  display: block;
  color: #333333;
  font-size: 18px;
  margin-bottom: 5px;
  font-weight: 400;
`


export const CommonInput = styled.input`
  display: block;
  width: 100%;
  padding: 10px;
  margin-bottom: 32px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
`

export const CommonSubmit = styled.input`
  display: block;
  height: 50px;
  width: auto;
  padding: 12px 50px 12px 50px;
  margin: 0 auto 32px;
  font-size: 18px;
  font-weight: 700;
  color: white;
  background-color: #0094B5;
  cursor: pointer;
  border-radius: 27px;
  border: none;
`

export const CommonLinkWrapper = styled.div`
  width: 100%;
  text-align: center;
  border: none;
  color: #0094B5;
  margin-bottom: 16px;
  cursor: pointer;
`

export const CommonFormTitle = styled.div`
  color: #0094B5;
  font-size: 30px;
  margin-top: 32px;
  margin-bottom: 32px;
  text-align: center;
  font-weight: 700;
`

/* modal */
export const ModalStyle = styled.div`
  background-color: #fff;
  padding: 60px 100px;
  border-radius: 10px;
  max-height: 80vh;
  overflow-y: scroll;
`

export const FormLabelInputWrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
  position: relative;
`

export const ModalTitle = styled.h1`
color: #0094B5;
font-size: 30px;
margin-bottom: 32px;
text-align: center;
font-weight: 700;
`

export const ModalSubTitle = styled.p`
  width: 500px;
  font-size: 20px;
  text-align: left;
  padding: 30px;
  font-weight: 500;
  white-space: pre-line; /* 改行を表示させるためのスタイル */
`

export const ModalForm = styled.form`
  width:500px;
`

export const ModalSubmit = styled.input`
  background-color: #1A4EA1;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 200px;
  display: block;
  margin: 0 auto 16px;
  font-size: 16px;
  opacity: ${props => props.disabled ? '0.3' : '1'};
`

export const LoadingContainer = styled.div`
  display: flex;
  height: 60px;
  justify-content: center;
  align-items: center;
`;

export const ModalSubmitButton = styled.button`
  background-color: #1A4EA1;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 200px;
  display: block;
  margin: 0 auto 16px;
  font-size: 16px;
`

export const ModalClose = styled.button`
  color: #333333;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 200px;
  display: block;
  margin: 16px auto 16px;
  font-size: 16px;
`

export const FormLabel = styled.label`
  color: #333333;
  font-size: 20px;
  flex-basis: 50%;
`
export const FormSelect = styled.select`
  color: #333333;
  font-size: 20px;
  flex-basis: 50%;
`

export const FormInput = styled.input`
  color: #333333;
  font-size: 20px;
  flex-basis: 50%;
`

export const IconWrapper = styled.div`
  position: absolute;
  right: -25px;
  top: 3px;
`

export const SubmitPerformanceButton = styled.button`
  color: white;
  background-color:#0094B5;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 200px;
  display: block;
  margin: 16px auto 16px;
  font-size: 16px;
`

export const SubmitPerformanceSpan = styled.span`
  color: white;
  background-color:#0094B5;
  border: none;
  padding: 5px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px
`

/* master */

export const DeletedContents = styled.div`
  background-color:#e67f73;
  color:white;
`


/* Page */

export const HomeTitle = styled.div`
  color: #0094B5;
  font-size: 30px;
  margin-top: 32px;
  margin-bottom: 32px;
  text-align: center;
  font-weight: 700;
`

export const PageTitle = styled.div`
  color: #0094B5;
  font-size: 30px;
  margin-top: 32px;
  margin-bottom: 32px;
  text-align: left;
  font-weight: 700;
`

export const Wrapper = styled.div`
  width: calc(100% - 200px);
`

export const Title = styled.legend`
    font-size: 20px;
    margin-bottom:20px;
    text-align: center;
`

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
`

export const Input = styled.input`
  display: block;
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
`

export const Submit = styled.input`
  width: 100%;
  background-color: #4CAF50;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;
`

export const CreateNew = styled.button`
  background-color: #1A4EA1;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 200px;
  display: block;
  margin-bottom: 16px;
  font-size: 16px;
`

export const DeleteUserButton = styled.button`
  background-color: red;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 200px;
  display: block;
  margin: 0 auto 16px;
  font-size: 16px;
`

export const DivFlex = styled.div`
  display: flex;
`

export const DivMargin = styled.div`
height: 16px;
width: 100%;
margin-bottom: '20px'
`

export const MaxForm = styled.form`
  max-width: 700px;
  margin: 0 auto;
`